(ns frontend.view.entity-viewers.modules.entity-esign.status-tag.view
  (:require
   [ui.util :as uu]))

(defn view
  [{:keys [label variant]}]
  [:div
   {:class (uu/cm "py-1 px-3 rounded-full text-xs m-0 text-nowrap bg-base-regular text-base-regular-text"
                  (case variant
                    :success "bg-primary-regular text-primary-regular-text"
                    :danger "bg-danger-regular text-danger-regular-text"
                    ""))}
   label])
